const siteEventNames = {
  ADD_EXPERT: 'addexpert',
  ADD_SWATCH: 'addswatch',
  DEALER_PHONE_CLICK: 'dealerphoneclick',
  DEALER_WEBSITE_CLICK: 'dealerwebsiteclick',
  ON_ACCOUNT_CREATED: 'onaccountcreated',
  ON_DEALER_SEARCH: 'ondealersearch',
  ON_FORM_SUBMIT_SUCCESS: 'onformsubmitsuccess',
  ON_LOGGED_IN: 'onloggedin',
  ON_ORDER_SUBMITTED: 'onordersubmitted',
  ON_ORDER_CONFIRMATION: 'onorderconfirmation',
  REMOVE_SWATCH: 'removeswatch',
};

const initSiteEvents = () => {
  if (window.siteEventRegistry) {
    return;
  }
  // Init events and add them to window scope here
  window.siteEventRegistry = {};
  Object.keys(siteEventNames).forEach((key) => {
    const value = siteEventNames[key];
    siteEventRegistry[value] = {
      event: new Event(value),
      data: {},
    }
  });
};

const getEventData = (eventName) => {
  const { siteEventRegistry } = window;
  let data = {};
  Object.keys(siteEventRegistry).forEach((key) => {
    if (key === eventName) {
      data = siteEventRegistry[key].data;
    }
  });
  return data;
}

const dispatchSiteEvent = (eventName, data) => {
  const { siteEventRegistry } = window;
  Object.keys(siteEventRegistry).forEach((key) => {
    if (key === eventName) {
      const event = siteEventRegistry[key].event;
      siteEventRegistry[key].data = data;
      window.dispatchEvent(event);
    }
  });
};

export {
  dispatchSiteEvent,
  getEventData,
  initSiteEvents,
  siteEventNames,
};
